module.exports = __webpack_public_path__ + "img/streak-breakpoint-marker.0d6bb53b.svg";